import { Component } from "react";
import styles from "./general-content-ad-list-item.module.less";
import { PrimaryButton, extract } from "@parksandresorts/core";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";

export default class GeneralContentAdListItem extends Component {
  constructor(props) {
    super(props);

    this.title = extract(props, "title");
    this.preamble = extract(props, "preamble.preamble");
    this.shortDescriptionInList = extract(props, "shortDescriptionInList");
    this.internalButtonUrl = extract(props, "adLink.internalLink.slug");
    this.buttonUrl = this.internalButtonUrl ? this.internalButtonUrl : extract(props, "adLink.externalUrl");
    this.buttonText = extract(props, "adLink.title");
    this.componentTheme = extract(props, "componentTheme");
    this.extraClass = extract(props, "extraClass", "");
  }

  render() {
    return (
      <LinkWrapper className={styles.link} url={this.buttonUrl}>
        <div
          className={[
            styles.componentWrapper,
            this.componentTheme ? `component-theme-${this.componentTheme}` : "",
          ].join(" ")}
        >
          <div className={[styles.wrapper, this.extraClass ? this.extraClass : ""].join(" ")}>
            <div className={styles.textWrapper}>
              {this.title && <h2 className={styles.headline}>{this.title}</h2>}
              {this.preamble && <p className={["preamble", styles.preamble].join(" ")}>{this.preamble}</p>}
              {this.shortDescriptionInList && (
                <p className={[styles.shortDescription, "p_small"].join(" ")}>{this.shortDescriptionInList}</p>
              )}
              {this.buttonUrl && this.buttonText && (
                <div className={styles.buttonWrapper}>
                  <PrimaryButton complementary label={this.buttonText} />
                </div>
              )}
            </div>
          </div>
        </div>
      </LinkWrapper>
    );
  }
}
